import "./styles.scss";
import researchgatelogo from "./../../assets/research_gate.png";
import arxivlogo from "./../../assets/arxivlogo.svg";
import googlescholar from "./../../assets/googlescholar.png";
import logicGroup from "./../../assets/logic_group.png";
import webpagelogo from "./../../assets/web_page.png";
import biblogo from "./../../assets/bibliography.png";


const Footer = () => {

    return (
        <div className={"Footer"} id={"links"}>
        <div className={"updated-date"}>This page has been discontinued.</div>
        </div>
    );
}

export default Footer;